import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import navigationItems from './navigationItems';

const Sidebar = ({ isOpen = true }) => {
  const sidebarVariants = {
    open: { x: 0 },
    closed: { x: '-100%' },
  };

  return (
    <motion.aside
      initial={false}
      animate={isOpen ? 'open' : 'closed'}
      variants={sidebarVariants}
      transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
      className="flex flex-col h-full bg-white text-gray-800 shadow-[0_8px_30px_rgb(0,0,0,0.12)] border-r border-gray-100"
    >
      {/* Premium Logo Section */}
      <div className="relative flex items-center justify-center h-24 overflow-hidden">
        {/* Subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-amber-50/50 via-transparent to-transparent" />
        
        <div className="relative flex items-center space-x-3">
          <div className="relative">
            <div className="absolute inset-0 bg-amber-400/20 blur-lg rounded-full" />
          </div>{/* logo */}
          <Link
            to="/"
            aria-label="Covrly Admin dashboard"
            className="relative flex items-center space-x-2"
          >
            <img
              src="https://symforklift.nyc3.cdn.digitaloceanspaces.com/fitness-logo.png"
              alt=""
              className="h-10 w-10 flex-shrink-0"
            />
            <span className="text-2xl font-light tracking-wider">
              Covrly <span className="font-semibold text-amber-600">Admin</span>
            </span>
          </Link>
        </div>
      </div>

      {/* Menu Items */}
      <nav
        aria-label="Primary navigation"
        className="flex-1 space-y-1.5 overflow-y-auto px-4 py-8 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-200"
      >
        {navigationItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `relative flex items-center px-5 py-3 text-sm font-medium rounded-2xl transition-all duration-300 group ${
                isActive
                  ? 'text-amber-600 bg-amber-50 shadow-sm'
                  : 'text-gray-600 hover:text-amber-600 hover:bg-gray-50'
              }`
            }
          >
            {({ isActive }) => (
              <>
                {/* Active indicator dot */}
                {isActive && (
                  <motion.div
                    layoutId="activeDot"
                    className="absolute left-0 w-1.5 h-1.5 bg-amber-600 rounded-full"
                    transition={{ duration: 0.2 }}
                  />
                )}
                
                <item.icon
                  aria-hidden="true"
                  className={`mr-4 h-5 w-5 flex-shrink-0 transition-transform duration-300 group-hover:scale-110 ${
                    isActive ? 'text-amber-600' : 'text-gray-400 group-hover:text-amber-600'
                  }`}
                />
                
                <span className="relative z-10 flex-1">{item.name}</span>
                
                {/* Subtle hover effect */}
                <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-r from-amber-50/50 to-transparent pointer-events-none" />
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </motion.aside>
  );
};

export default Sidebar;
